/* global window */
import * as Highcharts from 'highcharts';
import Plot from './Plot';

export default function ImpactAnalysisGraphController(
  $scope,
  $q,
  $timeout,
  brandColors
) {
  const vm = this;

  // TODO: Bug when vm.process is undefined
  vm.process.recoveryTimeObjective = vm.process.recoveryTimeObjective || 0;
  vm.process.maximumAcceptableDowntime = vm.process.maximumAcceptableDowntime || 0;
  vm.render = _render;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    _initEventListeners();
  }

  function _initEventListeners() {
    $scope.$on(
      'reRenderImpactAnalysisGraph',
      ($event, args) => {
        if (args.processId === vm.process.processId) {
          _render();
        }
      }
    );
  }

  function _render() {
    const elements = angular.element(`.bcp-impact-analysis-graph[data-process-id="${vm.process.processId}"]`);
    const dfdRender = $q.defer();
    const riskValues = getRiskValues(vm.process.assessmentProcessRisks);

    vm.process.recoveryTimeObjective = sanitizeNumber(vm.process.recoveryTimeObjective);
    vm.process.maximumAcceptableDowntime = sanitizeNumber(vm.process.maximumAcceptableDowntime);

    // Label positioning must shift at different RTOs to avoid label overlap
    const plot = new Plot(vm.process.maximumAcceptableDowntime, vm.process.recoveryTimeObjective, brandColors);
    const plotBands = plot.getPlotBands(riskValues.instructionText);
    const plotBandsToChart = [];

    if (plotBands.noMADPlotBand) {
      plotBandsToChart.push(plotBands.noMADPlotBand);
    }
    if (plotBands.targetPlotBand) {
      plotBandsToChart.push(plotBands.targetPlotBand);
    }
    if (plotBands.acceptablePlotBand) {
      plotBandsToChart.push(plotBands.acceptablePlotBand);
    }
    if (plotBands.unacceptablePlotBand) {
      plotBandsToChart.push(plotBands.unacceptablePlotBand);
    }

    angular.forEach(elements, (element) => {
      createChart(
        element,
        plotBands.plotLines,
        plotBandsToChart,
        riskValues.operationalValues,
        riskValues.regulatoryValues,
        riskValues.strategicValues,
        riskValues.reputationValues
      );
    });

    $timeout(() => {
      angular.element(window).trigger('resize');
    }, 50);

    dfdRender.resolve();
    return dfdRender.promise;
  }

  function getRiskValues(assessmentProcessRisks) {
    const operationalValues = [];
    const regulatoryValues = [];
    const strategicValues = [];
    const reputationValues = [];
    let instructionText = 'Fill Out Risk Table';

    angular.forEach(
      assessmentProcessRisks,
      (processRisk) => {
        operationalValues.push(processRisk.operationalRiskValue);
        regulatoryValues.push(processRisk.regulatoryRiskValue);
        strategicValues.push(processRisk.strategicRiskValue);
        reputationValues.push(processRisk.reputationalRiskValue);
        if (
          processRisk.operationalRiskValue > 0
          || processRisk.regulatoryRiskValue > 0
          || processRisk.strategicRiskValue > 0
          || processRisk.reputationalRiskValue > 0
        ) {
          instructionText = '';
        }
      }
    );
    return {
      instructionText,
      operationalValues,
      regulatoryValues,
      strategicValues,
      reputationValues
    };
  }

  function sanitizeNumber(n) {
    const parsed = parseFloat(n);
    const isNum = !isNaN(parsed) && isFinite(n);

    return isNum ? parsed : 0;
  }

  function createChart(
    element,
    plotLines,
    plotBands,
    operationalValues,
    regulatoryValues,
    strategicValues,
    reputationValues
  ) {
    Highcharts.chart(element, {
      chart: {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
      },
      colors: [
        brandColors.navantaCoral.$100,
        brandColors.justNavy.$100,
        brandColors.hulaSkirtGreen.$100,
        brandColors.navantaPlum.$100,
      ],
      xAxis: {
        title: {
          text: 'Days to Recover',
          offset: 30,
        },
        labels: {
          formatter() {
            return this.value === 0
              ? '< 1/2'
              : this.value;
          },
          step: 2,
          y: 20,
        },
        min: 0,
        max: 10,
        tickInterval: 0.5,
        plotLines,
        plotBands,
      },
      yAxis: {
        title: {
          text: 'Risk',
          x: 0,
        },
        labels: {
          x: -20,
        },
        min: 0,
        max: 10,
        tickInterval: 1,
      },
      title: {
        align: 'left',
        margin: 35,
        x: 10,
        style: {
          fontFamily: '\'Nunito\', sans-serif',
          fontSize: 17,
          color: brandColors.navantaPlum.$100,
        },
        text: 'Business Impact Analysis Graph',
      },
      credits: {
        enabled: false,
        href: '',
        text: '',
      },
      legend: {
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'middle',
        borderWidth: 0,
      },
      series: [
        {
          name: 'Operational',
          data: operationalValues,
        }, {
          name: 'Regulatory',
          data: regulatoryValues,
        }, {
          name: 'Strategic',
          data: strategicValues,
        }, {
          name: 'Reputation',
          data: reputationValues,
        },
      ],
      tooltip: {
        formatter() {
          return `<div style="font-weight: bold; color: ${this.series.color};">${this.series.name}</div><br>`
            + `<div>${this.x} day${(this.x > 0 && this.x < 1.5) ? '' : 's'} to recover is ${this.y} risk</div>`;
        },
      },
    });
    // element.highcharts();
  }
}

ImpactAnalysisGraphController.$inject = [
  '$scope',
  '$q',
  '$timeout',
  'brandColors'
];
